<div class="child-panel card text-white border border-grey">
  <div class="card-body bg-primary p-3">
    <div class="child-panel-details">
      <div class="child-panel-name">
        <h5 class="mb-2">{{ child.Firstname }} {{ child.Lastname }}</h5>
        <ng-container [ngSwitch]="child.AccountPaymentState">
          <span class="font-size-12" *ngSwitchDefault>{{
            'child.panel.member.free.text' | translate: { fgbdefault: 'Rookie' }
          }}</span>
          <span class="font-size-12" *ngSwitchCase="1">{{
            'child.panel.member.paid.text' | translate: { fgbdefault: 'All-Star Member' }
          }}</span>
        </ng-container>
      </div>
      <div class="child-panel-dob">
        <label class="">{{ 'child.panel.dob' | translate }}</label>
        <span class="font-size-12">
          {{ child.DateOfBirth | date: 'MMM dd, yyyy' }}
        </span>
      </div>
    </div>
    <div class="img-wrapper">
      <img src="assets/images/nav-logo.svg" draggable="false" />
    </div>
  </div>
  <div class="button-wrapper w-100 bg-secondary login-kids-panel">
    <button
      type="button"
      (click)="loginToChild()"
      class="btn btn-primary mobile-child-login-btn fw-bold text-white cursor-pointer"
    >
      {{ 'child.panel.login' | translate }}
    </button>
  </div>
</div>

<!-- Barcode modal -->
<ng-template #barcodeModal let-modal>
  <div class="child-barcode-modal">
    <div class="child-barcode-modal-body">
      <button class="child-barcode-modal-close-btn" (click)="modal.close()">
        <i class="material-icons">close</i>
      </button>
      <div class="child-panel-name pt-3">
        <h5 class="mb-0">{{ child.Firstname }} {{ child.Lastname }}</h5>
        <ng-container [ngSwitch]="child.AccountPaymentState">
          <span class="font-size-10" *ngSwitchDefault>{{
            'child.panel.member.free.text' | translate: { fgbdefault: 'Club Member' }
          }}</span>
          <span class="font-size-10" *ngSwitchCase="1">{{
            'child.panel.member.paid.text' | translate: { fgbdefault: 'All-Star' }
          }}</span>
        </ng-container>
      </div>
      <div class="barcode-wrapper">
        <qrcode [qrdata]="child.CardBarcode" [width]="150" [errorCorrectionLevel]="'M'" [elementType]="true"></qrcode>
      </div>
    </div>
    <div class="child-barcode-modal-footer bg-primary text-white">
      <div class="child-barcode-dob">
        <label class="mb-0">{{ 'child.panel.dob' | translate }}</label>
        <span class="font-size-14">
          {{ child.DateOfBirth | date: 'MMM dd, yyyy' }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
